import { createSlice } from '@reduxjs/toolkit';
import { initialState, commonReducers } from './fileVersionHistory.slice';

const toolboxVersionHistorySlice = createSlice({
  name: 'toolboxVersionHistory',
  initialState,
  reducers: { ...commonReducers },
});

export default toolboxVersionHistorySlice.reducer;
export const {
  setOpenFileVersionHistory,
  setOpenDeleteVersionConfirmationModal,
  addToFileVersions,
  getNextVersions,
  deletedLastVersion,
} = toolboxVersionHistorySlice.actions;
